import { render, staticRenderFns } from "./NoteDialog.vue?vue&type=template&id=2f8bb0e4&scoped=true&lang=pug&"
import script from "./NoteDialog.vue?vue&type=script&lang=ts&"
export * from "./NoteDialog.vue?vue&type=script&lang=ts&"
import style0 from "./NoteDialog.vue?vue&type=style&index=0&id=2f8bb0e4&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f8bb0e4",
  null
  
)

export default component.exports